module.exports = __webpack_public_path__ + "img/canal.2c9df856.svg";